<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="convenientIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a  href="javascript:void(0)" @click="urlTo('convenientIndex')">便民查询</a>/<a  href="javascript:void(0)" style="color: #b7b7b7" @click="urlTo('orgSearch',{code:code,name:title})">{{title}}查询</a><span>/{{title}}详情</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="personal" style="width: 100%;">
            <div class="personal_right" style="width: 100%;">
              <el-card class="box-card" shadow="hover"
                       style="width: 100%;font-size: 14px;"
              >

                <div v-for="(item,index) in  dataObjList" class="text detail"  style="line-height: 40px; margin-left: 30px;margin-right: 30px;margin-top: 20px" >

                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">单位名称：{{item.osiName}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.lastTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">信用代码：{{item.idcardNum}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">法定代表人：{{item.legalName}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">登记时间：{{item.createdDate}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">联系人：{{item.workMan}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">联系电话：{{item.workTel}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">机构类型：{{item.osiCatagoryName}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">机构性质：{{item.wiClassName}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div v-if="itemData.businessScope !=''" style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">业务范围：{{item.businessScope}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.s_title}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">办公地址：{{item.workAddress}}</span><span class="yy_title_content"style="font-size: 14px">{{detail.lastTime}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title" style="font-size: 14px">地图展示：</span><span class="yy_title_content"style="font-size: 14px">{{detail.content}}</span></div>
                  </div>
                <div>
                  <baidu-map    :zoom="map_zoom" @ready="map_handler" :center="location" :double-click-zoom="true"  ak="v5Nf1GsXWG4qqBFFOVREZhamB29A13XL"  :style="{width:'100%',height:'500px'}">
                  </baidu-map>
                </div>
                  <div style="height: 50px;width: 100%;"></div>
                </div>

              </el-card>
              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import BaiduMap from "vue-baidu-map/components/map/Map.vue"
  import BmView from 'vue-baidu-map/components/map/MapView.vue'
  import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue'
  export default {
    name: "SuggestDetail",
    components: {
      headers, fixedDiv, footers,
      BaiduMap,
      BmView,
      BmLocalSearch,
    },
    data() {
      return {
        detail: {},
        detail_id: '',
        html_url: '',
        title: '',
        code: '',
        itemData:null,
        active: 0,
        dataObjList: [],
        tabName: '投诉',
        type:'1',
        map:null,
        map_zoom :15,
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        widths:document.body.clientWidth-50+'px',
        location: {
        },
        maps:{},
        lng:'',
        lat:'',
      }
    },
    created() {
      this.detail_id = this.$route.query.detail_id;
      this.title=this.$route.query.title;
      //返回上一页需要的code
      this.code=this.$route.query.code;
      this.getDetail();
    },
    methods: {
      //获取政策文件详细
      getDetail() {
        var _wdid='';
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        const options={
          detailId:this.detail_id,
        };
        var t=this;
        this.$https.post("api/orgservice/getOrgServices.do",options,response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data) {
            if(response.data.data.dataList && response.data.data.dataList.length>0){
              t.dataObjList=response.data.data.dataList;
              for (let i = 0; i < t.dataObjList.length; i++) {
                t.itemData=t.dataObjList[0];
                this.location={
                  lng: t.itemData.mapLon,
                  lat: t.itemData.mapLat
                }
                if(this.map){
                  this.map.clearOverlays();
                  this.addMark()
                }
              }
              t.total=response.data.data.total;
            }
          }
        })
      },
      //下载附件
      downloadAttach() {
        // this.$https.downloadFile("/attach/download.do", {attachId: this.detail.attachIdList[0],}, response => {
        // });
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      map_handler({ BMap, map }) {
        console.log("map_handler")
        let _this = this
        this.BMap = BMap
        this.map = map
        this.map_zoom = 15

        this.addMark()

      },
      addMark(){
        // 在地图上添加点标记
        //  map.addOverlay(marker1);
        var marker = new BMap.Marker(new BMap.Point(this.location.lng, this.location.lat));  // 创建标注
        var label = new BMap.Label(this.itemData.osiName,{offset:new BMap.Size(20,-15)});
        label.setStyle({
          fontSize : "12px",
          height : "25px",
          lineHeight : "25px",
          fontFamily:"微软雅黑",
          borderColor: '#ccc',
          paddingLeft:"5px",
          paddingRight:"5px"
        });
        var opts = {
          width : 200,     // 信息窗口宽度
          height: 0,     // 信息窗口高度

        }
        var t=this;


        var licontent="<b>"+this.itemData.osiName+"</b><br><br>";
        licontent+="<span><strong>地址：</strong>"+this.itemData.workAddress+"</span><br>";
       licontent+="<span style='float: right;bottom: 0px;margin-right:5px'><a href='http://api.map.baidu.com/geocoder?location="+this.location.lat+","+this.location.lng+"&coord_type=bd09ll&output=html&src=webapp.jjkj.pu' target='_blank'>到这去</a><br><br>";
        var infoWindow = new BMap.InfoWindow(licontent, opts);  // 创建信息窗口对象
        marker.addEventListener("click", function(){
          t.map.openInfoWindow(infoWindow,new BMap.Point(t.location.lng, t.location.lat)); //开启信息窗口
        });
        label.addEventListener("click", function(){
          t.map.openInfoWindow(infoWindow,new BMap.Point(t.location.lng, t.location.lat)); //开启信息窗口
        });
        marker.setLabel(label);
        marker.setAnimation(BMAP_ANIMATION_BOUNCE); //跳动的动画
        // 将标注添加到地图中
        // 添加图标marker
        setTimeout(() => {
          t.map.addOverlay(marker);
          t.map.centerAndZoom(new BMap.Point(t.location.lng, t.location.lat), 15);
        }, 100);
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/search/OrgSearchDetail.vue